import { TemplateVariablesMap } from '@tools/interfaces/template';
import { templateBooking } from './template-booking';
import { templateBookingEvent } from './template-booking-events';
import { templateActivitySession } from './template-activity-session';
import { templateAttendee } from './template-attendee';
import { templateContact } from './template-contact';
import { templateContract } from './template-contract';
import { templateEnrollment } from './template-enrollment';
import { templateEntry } from './template-entry';
import { templateSubscription } from './template-subscription';
import { templateInvoice } from './template-invoice';
import { templateMandate } from './template-mandate';
import { templateWaitingContact } from './template-waiting-contact';
import { templateActivitySessionWaitingContact } from './template-activity-session-waiting-contact';
import { templateAccessControlBadge } from './template-access-control-badge';
import { templateGlobal } from './template-global';
import { templateTaxCertificate } from '@tools/config/template-tax-certificate';

export const templateVariables: TemplateVariablesMap = {
  booking: templateBooking,
  booking_event: templateBookingEvent,
  subscription: templateSubscription,
  entry: templateEntry,
  contact: templateContact,
  contract: templateContract,
  invoice: templateInvoice,
  mandate: templateMandate,
  enrollment: templateEnrollment,
  activity_group_waiting_contact: templateWaitingContact,
  activity_session_waiting_contact: templateActivitySessionWaitingContact,
  activity_session: templateActivitySession,
  activity_session_attendee: templateAttendee,
  global: templateGlobal,
  tax_certificate: templateTaxCertificate,
  access_control_badge: templateAccessControlBadge,
};

type LabelDescriptionPair = {
  label: string;
  description: string;
};

// NOTE helper method to get all the keys to translate
export const getTranslationKeys = () => {
  const result: LabelDescriptionPair[] = [];

  Object.values(templateVariables).forEach(entityTemplateVariable => {
    if (!entityTemplateVariable) return;

    // Extract from fields
    entityTemplateVariable.fields.forEach(field => {
      result.push({
        label: field.label,
        description: field.description,
      });
    });

    // Extract from related
    entityTemplateVariable.related.forEach(relation => {
      result.push({
        label: relation.label,
        description: relation.description,
      });
      relation.fields.forEach(field => {
        result.push({
          label: field.label,
          description: field.description,
        });
      });
    });

    // Extract from relatedInLoop
    entityTemplateVariable.relatedInLoop.forEach(relation => {
      result.push({
        label: relation.label,
        description: relation.description,
      });
      relation.fields.forEach(field => {
        result.push({
          label: field.label,
          description: field.description,
        });
      });
    });
  });
  const flatResultLabels = result.map(item => item.label);
  const flatResultDescriptions = result.map(item => item.description);
  return [...new Set(flatResultLabels), ...new Set(flatResultDescriptions)].sort();
};
